// WHY: оптимизатор Next пропускает только хосты из images.remotePatterns в next.config.mjs — префиксы должны совпадать с ними
const OPTIMIZED_PREFIXES = [
  'https://shot.band/images/',
  'https://community.akamai.steamstatic.com/economy/image/',
  'https://community.fastly.steamstatic.com/',
  'https://community.cloudflare.steamstatic.com/',
  'https://steamcdn-a.akamaihd.net/',
  'https://steamcommunity-a.akamaihd.net/economy/image/',
];

const QUALITY = 75;

export const isOptimizable = (src: string): boolean => OPTIMIZED_PREFIXES.some((prefix) => src.startsWith(prefix));

export const optimizerUrl = (src: string, width: number): string =>
  `/_next/image?url=${encodeURIComponent(src)}&w=${width}&q=${QUALITY}`;

export const optimizerSrcSet = (src: string, widths: readonly number[]): string | undefined =>
  isOptimizable(src) ? widths.map((width) => `${optimizerUrl(src, width)} ${width}w`).join(', ') : undefined;
